/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * Swym Wishlistボタンをvendor横に移動 & 再初期化
 */
(function() {
  var debounceTimer = null;
  var swymReinitTimer = null;

  // Swymボタンの再初期化（デバウンス付き）
  function reinitializeSwym() {
    if (swymReinitTimer) {
      clearTimeout(swymReinitTimer);
    }
    swymReinitTimer = setTimeout(function() {
      if (typeof window._swat !== 'undefined') {
        // Swymのボタンを再初期化
        if (window._swat.initializeActionButtons) {
          window._swat.initializeActionButtons();
        }
        // Wishlistボタンも再初期化
        if (window._swat.initializeWishlistButtons) {
          window._swat.initializeWishlistButtons();
        }
        // SwymReady経由でも再初期化を試みる
        if (typeof window.SwymCallbacks !== 'undefined') {
          window.SwymCallbacks.push(function(swat) {
            swat.initializeActionButtons();
          });
        }
      }
    }, 100);
  }

  // Swymの完全再初期化（Recently Viewed用）
  function forceReinitializeSwym() {
    if (typeof window._swat !== 'undefined') {
      // 少し遅延を入れて確実に実行
      setTimeout(function() {
        if (window._swat.initializeActionButtons) {
          window._swat.initializeActionButtons();
        }
        if (window._swat.initializeWishlistButtons) {
          window._swat.initializeWishlistButtons();
        }
      }, 300);
      // さらに遅延して再度実行（確実性を上げる）
      setTimeout(function() {
        if (window._swat.initializeActionButtons) {
          window._swat.initializeActionButtons();
        }
      }, 800);
    }
  }

  function moveWishlistButtons() {
    // 通常のShopify商品一覧
    document.querySelectorAll('.product-item').forEach(function(item) {
      var swymContainer = item.querySelector('.swym-wishlist-collections-v2-container');
      var vendorEl = item.querySelector('.product-item-meta__vendor');

      if (swymContainer && vendorEl && !swymContainer.dataset.moved) {
        var vendorParent = vendorEl.parentNode;
        var wrapper = document.createElement('div');
        wrapper.className = 'product-item-meta__vendor-wrapper';
        vendorParent.insertBefore(wrapper, vendorEl);
        wrapper.appendChild(vendorEl);
        wrapper.appendChild(swymContainer);
        swymContainer.dataset.moved = 'true';
      }
    });

    // BoostAI商品一覧
    document.querySelectorAll('.boost-sd__product-item').forEach(function(item) {
      var swymButton = item.querySelector('.swym-button.swym-add-to-wishlist-view-product');
      var vendorEl = item.querySelector('.boost-sd__product-vendor');

      if (swymButton && vendorEl && !swymButton.dataset.moved) {
        // 既存のvendor wrapperを探す、なければvendorの親要素を使う
        var wrapper = vendorEl.closest('.boost-sd__product-vendor-wrapper') || vendorEl.parentNode;

        // wrapperにクラスを追加（スタイル用）
        wrapper.classList.add('boost-sd__vendor-wrapper');

        // ボタンをwrapperに追加
        wrapper.appendChild(swymButton);
        swymButton.dataset.moved = 'true';
      }
    });
  }

  // デバウンス付きの処理
  function debouncedProcess() {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(function() {
      moveWishlistButtons();
      reinitializeSwym();
    }, 200);
  }

  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(debouncedProcess, 500);
    });
  } else {
    setTimeout(debouncedProcess, 500);
  }

  // ページ遷移時（instant page / Turbo）の再初期化
  document.addEventListener('page:load', debouncedProcess);
  document.addEventListener('turbo:load', debouncedProcess);
  // Focalテーマのページ遷移イベント
  document.addEventListener('theme:loading:end', debouncedProcess);

  // Swymの読み込み完了を監視（デバウンス付き）
  var observer = new MutationObserver(function(mutations) {
    var hasRelevantChanges = mutations.some(function(mutation) {
      return Array.from(mutation.addedNodes).some(function(node) {
        if (node.nodeType !== 1) return false;
        // Swym関連またはproduct-item関連の要素が追加された場合のみ処理
        return node.classList && (
          node.classList.contains('swym-wishlist-collections-v2-container') ||
          node.classList.contains('product-item') ||
          node.classList.contains('boost-sd__product-item') ||
          node.classList.contains('recently-viewed') ||
          node.classList.contains('product-list__inner') ||
          node.querySelector && (
            node.querySelector('.swym-wishlist-collections-v2-container') ||
            node.querySelector('.product-item') ||
            node.querySelector('.recently-viewed')
          )
        );
      });
    });

    if (hasRelevantChanges) {
      debouncedProcess();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Recently Viewedのカスタム要素が読み込まれた時のイベント
  document.addEventListener('recently-viewed:loaded', function() {
    debouncedProcess();
    forceReinitializeSwym();
  });

  // タブがアクティブに戻った時の再初期化
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      forceReinitializeSwym();
      debouncedProcess();
    }
  });

  // ページフォーカス時の再初期化
  window.addEventListener('focus', function() {
    forceReinitializeSwym();
  });
})();